export default {
  dashboard: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  permissions: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  updateDash: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  embed: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  cache: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  statusCache: {
    loading: false,
    lastUpdate: null,
    data: {},
  },
  // {{NEXT}}
}
